import 'assets/icon/css/keepaapp.css';
import 'assets/scss/reset.scss';
import ErrorBoundary from 'components/ErrorBoundaries/ErrorBoundaries';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'redux/store';
import RTL from 'theme/RTL.jsx';
import App from './App';

ReactDOM.render(
	<BrowserRouter>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<ToastContainer
					position="top-center"
					hideProgressBar={true}
					closeOnClick
					draggable
					pauseOnHover
					pauseOnFocusLoss
					rtl
					closeButton={false}
					autoClose={1000}
				/>
				<ErrorBoundary fallback={'error'}>
					<RTL>
						<App />
					</RTL>
				</ErrorBoundary>
			</PersistGate>
		</Provider>
	</BrowserRouter>,
	document.getElementById('root'),
);
